import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader, Row, Col, Button } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
// Componentes
import ColorPicker from "../../components/ColorPicker/ColorPicker";
// service
import { editStatusRsvp } from "../../utils/services/statusRsvp";
import ButtonSpinner from "../../components/Buttons/ButtonSpinner";

export default function ModalEditStatusRsvp(props) {
  const { isOpen, toggle, editOneStatusRsvp, getListStatusRsvp } = props;

  // State de dados do formulário
  const [descriptionError, setDescriptionError] = useState("");
  const [backgroundColor, setBackgroundColor] = useState(
    editOneStatusRsvp?.backgroundColor || "#ffffff",
  );
  const [textColor, setTextColor] = useState(
    editOneStatusRsvp?.textColor || "#000000",
  );

  // State de modais/alertas
  const [alertSuccess, setAlertSuccess] = useState(false);
  const [alertError, setAlertError] = useState("");

  // State de loading
  const [isLoading, setIsloading] = useState(false);

  // Valida os campos obrigatórios antes de enviar
  function verifyForm(e) {
    // e.target[0] = input do id (disabled), e.target[1] = input do Status.
    if (!e.target[1].value) {
      setDescriptionError("O campo Status é obrigatório");
      return;
    }
    setDescriptionError("");
    submitForm(e);
  }

  // Envia o payload parcial para o backend
  async function submitForm(e) {
    const data = {
      description: e.target[1].value,
      backgroundColor,
      textColor,
    };
    setIsloading(true);
    const res = await editStatusRsvp({ id: editOneStatusRsvp.id, data });
    setIsloading(false);
    if (res && res.status >= 200 && res.status < 300) {
      setAlertSuccess(true);
      return;
    }
    if (res?.data?.message === "DESCRIPTION_ALREADY_EXISTS") {
      setAlertError("Já existe um status com essa descrição.");
      return;
    }
    setAlertError("Não foi possível editar o status. Tente novamente.");
  }

  return (
    <>
      {alertSuccess && (
        <SweetAlert
          success
          title="Editado"
          onConfirm={() => {
            getListStatusRsvp();
            toggle();
          }}
        >
          Status RSVP editado com sucesso!
        </SweetAlert>
      )}

      {alertError && (
        <SweetAlert
          warning
          title="Atenção"
          confirmBtnText="Ok"
          confirmBtnBsStyle="success"
          onConfirm={() => setAlertError("")}
        >
          {alertError}
        </SweetAlert>
      )}

      <Modal isOpen={isOpen} centered autoFocus>
        <ModalHeader toggle={toggle}>Editar Status RSVP</ModalHeader>
        <ModalBody>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              verifyForm(e);
            }}
          >
            <Row>
              <Col lg={12}>
                <label className="form-label">ID</label>
                <input
                  className="form-control"
                  type="text"
                  disabled
                  value={editOneStatusRsvp.id}
                />
              </Col>
            </Row>

            <Row style={{ marginTop: 10 }}>
              <Col lg={12}>
                <label className="form-label">Status*</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={editOneStatusRsvp.description}
                />

                {descriptionError && (
                  <span style={{ color: "red" }}>{descriptionError}</span>
                )}
              </Col>
            </Row>

            <Row style={{ marginTop: 15 }}>
              <Col md={6}>
                <ColorPicker
                  classOfContainer="status-rsvp-edit-bg-pickr"
                  labelText="Cor de Fundo"
                  setStateFunc={setBackgroundColor}
                  defaultColor={backgroundColor}
                />
              </Col>
              <Col md={6}>
                <ColorPicker
                  classOfContainer="status-rsvp-edit-text-pickr"
                  labelText="Cor do Texto"
                  setStateFunc={setTextColor}
                  defaultColor={textColor}
                />
              </Col>
            </Row>

            <Row>
              <Col
                md={12}
                style={{
                  width: "100%",
                  margin: "auto",
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 20,
                }}
              >
                <Button
                  color="danger"
                  className="btn btn-danger waves-effect waves-light"
                  style={{ width: 80 }}
                  onClick={() => toggle()}
                >
                  Fechar
                </Button>
                <ButtonSpinner
                  isLoading={isLoading}
                  title="Salvar"
                  action="U"
                  marginLeft={10}
                />
              </Col>
            </Row>
          </form>
        </ModalBody>
      </Modal>
    </>
  );
}
